import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useAuth } from '../../_helper/Auth/AuthProvider'
import { getIdData } from '../../lib/studentinfo'
import { StudentTopMenuLayout } from '../../Layout/StudentTopMenu/StudentTopMenuLayout'
import { IframeViewer } from './IframeViewer'

const StudentIframePage = ({ activeMenu, pageName, linkField, title }) => {
	const { studentId } = useParams()
	const { user } = useAuth()
	const isInstructorView = user?.role === 'Instructor'
	const effectiveStudentId = isInstructorView ? studentId : user?.id
	const [studentInfo, setStudentInfo] = useState(null)
	const [loading, setLoading] = useState(true)

	const getStudentData = async () => {
		try {
			setLoading(true)
			const std = await getIdData(effectiveStudentId)
			if (std && std.length > 0) {
				setStudentInfo(std[0])
			}
		} catch (error) {
			console.error('Error fetching student data:', error)
		} finally {
			setLoading(false)
		}
	}

	useEffect(() => {
		if (effectiveStudentId) {
			getStudentData()
		}
	}, [effectiveStudentId])

	if (loading) {
		return (
			<div className="container-fluid">
				<div className="text-center">
					<div className="spinner-border" role="status">
						<span className="visually-hidden">Loading...</span>
					</div>
					<p className="mt-2">Loading {title.toLowerCase()}...</p>
				</div>
			</div>
		)
	}

	return (
		<StudentTopMenuLayout activeMenu={activeMenu} pageName={pageName}>
			<IframeViewer link={studentInfo?.[linkField]} title={title} />
		</StudentTopMenuLayout>
	)
}

export { StudentIframePage }
